import { useEstablishmentLead } from "@/features/establishmentLeadsFunnel/hooks/useEstablishmentLead"
import { useParams } from "react-router-dom"
import Form from "./form"

const Update = () => {
  const { establishmentLeadId } = useParams()
  const { data: establishmentLead, isPending: isLoadingEstablishmentLead } = useEstablishmentLead(establishmentLeadId || '')

  return (
    <>
      {(!isLoadingEstablishmentLead && establishmentLead) && (
        <Form establishmentLead={establishmentLead} />
      )}
    </>
  )
}

export default Update